import { TABS } from "../constants/common";

export const getTabObject = (selectedTab) => TABS.find(tab=>tab.value === selectedTab);